import script from "./ReportSioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportSioPage.vue?vue&type=script&setup=true&lang=js"

import "./ReportSioPage.vue?vue&type=style&index=0&id=4c41cf40&scoped=true&lang=css"
import "./ReportSioPage.vue?vue&type=style&index=1&id=4c41cf40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c41cf40"]])

export default __exports__